// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tree__lists_87772ac7 {
  display: flex;
  margin-top: -0.501rem;
}
.tree__list-wrapper_87772ac7 {
  overflow: hidden;
  flex: 1 1;
  padding: 0.334rem;
  margin: -0.334rem;
}
.tree__list_87772ac7 {
  margin-left: 1.833rem;
  max-width: 100%;
}
.tree__list_87772ac7:first-child > .tree__item_87772ac7:first-child {
  margin-top: 0;
}
.tree__item_87772ac7 {
  margin-top: 0.501rem;
  display: flex;
}
.tree__item_always-expanded_87772ac7 {
  margin-left: -1.833rem;
}
.tree__item_no-top-margin_87772ac7 {
  margin-top: 0;
}
.tree__item_bold-shifted_87772ac7:not(:first-child):not(.tree__item_hidden_87772ac7) {
  margin-top: 1.334rem;
}
.tree__box-v2_87772ac7 {
  min-width: 100%;
  padding: 0.334rem;
  margin: -0.334rem;
}
.tree__box-v2_87772ac7:not(.tree__box-v2_transient_87772ac7) {
  overflow: hidden;
}
.tree__box-v2_transient_87772ac7 {
  max-width: 100%;
}
.tree__nested_87772ac7 {
  display: inline-block;
  margin-left: -1.833rem;
  margin-top: 0.167rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tree__lists": `tree__lists_87772ac7`,
	"tree__list-wrapper": `tree__list-wrapper_87772ac7`,
	"tree__list": `tree__list_87772ac7`,
	"tree__item": `tree__item_87772ac7`,
	"tree__item_always-expanded": `tree__item_always-expanded_87772ac7`,
	"tree__item_no-top-margin": `tree__item_no-top-margin_87772ac7`,
	"tree__item_bold-shifted": `tree__item_bold-shifted_87772ac7`,
	"tree__item_hidden": `tree__item_hidden_87772ac7`,
	"tree__box-v2": `tree__box-v2_87772ac7`,
	"tree__box-v2_transient": `tree__box-v2_transient_87772ac7`,
	"tree__nested": `tree__nested_87772ac7`
};
export default ___CSS_LOADER_EXPORT___;
